<ion-content class="team-access-page-content">
  <div class="team-access-page">
    <aside class="team-sidebar">
      <app-team-listing-sidebar
        [team]="team"
        [canManageTeams]="canManageTeams"
        (teamChangeEvent)="handleSidebarTeamChange($event)"
      ></app-team-listing-sidebar>
    </aside>
    <section class="team-content-wrapper team-access-content-wrapper">
      <div class="team-access-content">
        <div class="team-access-header">
          <div>
            <ion-title>Team Permissions</ion-title>
            <div class="team-access-subtitle" *ngIf="team?.teamName">{{ team.teamName }}</div>
          </div>
          <button type="button" class="save-access-button" [disabled]="currentSaveDisabled" (click)="saveActiveChanges()">
            {{ currentSaveLabel }}
          </button>
        </div>

        <p class="team-access-description">{{ currentDescription }}</p>

        <div class="team-access-editor-switch">
          <button
            type="button"
            class="team-access-editor-option"
            [class.is-active]="activeEditor === 'team'"
            (click)="setActiveEditor('team')"
          >
            Team Permissions
          </button>
          <button
            type="button"
            class="team-access-editor-option"
            [class.is-active]="activeEditor === 'member'"
            (click)="setActiveEditor('member')"
          >
            Member Exceptions
          </button>
        </div>

        <div class="team-access-state team-access-error" *ngIf="loadError">{{ loadError }}</div>
        <div class="team-access-state" *ngIf="isLoading && !loadError">Loading team access...</div>

        <div class="team-access-body" *ngIf="!isLoading && !loadError">
          <div class="team-access-summary">{{ currentSummary }}</div>

          <ng-container *ngIf="activeEditor === 'team'">
            <div class="team-access-groups" *ngIf="teamAccessClients.length; else noOperations">
              <div class="team-access-group access-card" *ngFor="let client of teamAccessClients">
                <div class="team-access-group-name access-card-header">
                  <div class="client-header-main">
                    <button type="button" class="client-expand-toggle" (click)="toggleClientExpanded(client)">
                      {{ client.expanded ? 'Hide' : 'Show' }}
                    </button>
                    <span class="client-name">{{ client.operationGroupName }}</span>
                    <span class="team-access-meta-pill" [class.is-emphasis]="client.enabled">
                      {{ getClientOperationAssignedCount(client) }} assigned / {{ getClientOperationEnabledCount(client) }} enabled
                    </span>
                  </div>
                  <div class="client-header-actions">
                    <label class="client-enable-toggle">
                      <input
                        type="checkbox"
                        [checked]="client.enabled"
                        (change)="toggleClientEnabled(client, $any($event.target).checked)"
                      />
                      <span>Client access enabled</span>
                    </label>
                  </div>
                </div>

                <div class="access-card-body" *ngIf="client.expanded">
                  <div class="client-mode-toolbar">
                    <div class="client-mode-options">
                      <label>
                        <input
                          type="radio"
                          [checked]="client.accessMode === 'allOperations'"
                          (change)="setClientAccessMode(client, 'allOperations')"
                          [disabled]="!client.enabled"
                        />
                        <span>All Operations</span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          [checked]="client.accessMode === 'selectedOperations'"
                          (change)="setClientAccessMode(client, 'selectedOperations')"
                          [disabled]="!client.enabled"
                        />
                        <span>Selected Operations</span>
                      </label>
                    </div>

                    <div class="client-bulk-toolbar">
                      <ion-select
                        class="role-select-control bulk-role-select"
                        interface="popover"
                        [ngModel]="client.bulkRoleId"
                        (ngModelChange)="client.bulkRoleId = $event"
                        [disabled]="!client.enabled"
                      >
                        <ion-select-option *ngFor="let role of roleOptions" [value]="role.value">
                          {{ role.label }}
                        </ion-select-option>
                      </ion-select>
                      <button
                        type="button"
                        class="bulk-action-button"
                        (click)="applyBulkRole(client, false)"
                        [disabled]="!client.enabled"
                      >
                        Fill Unassigned
                      </button>
                      <button
                        type="button"
                        class="bulk-action-button"
                        (click)="applyBulkRole(client, true)"
                        [disabled]="!client.enabled"
                      >
                        Overwrite All
                      </button>
                      <button
                        type="button"
                        class="bulk-action-button is-danger"
                        (click)="clearClientRoles(client)"
                        [disabled]="!client.enabled"
                      >
                        Clear Defaults
                      </button>
                    </div>
                  </div>

                  <div class="client-assignee-toolbar">
                    <div class="client-assignee-section">
                      <div class="assignee-section-label">Default Manager</div>
                      <ion-select
                        class="role-select-control bulk-role-select"
                        interface="popover"
                        [ngModel]="client.bulkManagerTeamMemberId"
                        (ngModelChange)="client.bulkManagerTeamMemberId = $event"
                        [disabled]="!client.enabled"
                      >
                        <ion-select-option value="">Unassigned</ion-select-option>
                        <ion-select-option *ngFor="let member of roleEligibleMembers.managerEligible" [value]="member.teamMemberId">
                          {{ member.teamMemberFirstName }} {{ member.teamMemberLastName }}
                        </ion-select-option>
                      </ion-select>
                      <button type="button" class="bulk-action-button" (click)="applyBulkAssignee(client, 'manager', false)" [disabled]="!client.enabled">
                        Fill Unassigned
                      </button>
                      <button type="button" class="bulk-action-button" (click)="applyBulkAssignee(client, 'manager', true)" [disabled]="!client.enabled">
                        Overwrite All
                      </button>
                      <button type="button" class="bulk-action-button is-danger" (click)="clearBulkAssignee(client, 'manager')" [disabled]="!client.enabled">
                        Clear
                      </button>
                    </div>
                    <div class="client-assignee-section">
                      <div class="assignee-section-label">Default Care Rep</div>
                      <ion-select
                        class="role-select-control bulk-role-select"
                        interface="popover"
                        [ngModel]="client.bulkCareRepTeamMemberId"
                        (ngModelChange)="client.bulkCareRepTeamMemberId = $event"
                        [disabled]="!client.enabled"
                      >
                        <ion-select-option value="">Unassigned</ion-select-option>
                        <ion-select-option *ngFor="let member of roleEligibleMembers.careRepEligible" [value]="member.teamMemberId">
                          {{ member.teamMemberFirstName }} {{ member.teamMemberLastName }}
                        </ion-select-option>
                      </ion-select>
                      <button type="button" class="bulk-action-button" (click)="applyBulkAssignee(client, 'careRep', false)" [disabled]="!client.enabled">
                        Fill Unassigned
                      </button>
                      <button type="button" class="bulk-action-button" (click)="applyBulkAssignee(client, 'careRep', true)" [disabled]="!client.enabled">
                        Overwrite All
                      </button>
                      <button type="button" class="bulk-action-button is-danger" (click)="clearBulkAssignee(client, 'careRep')" [disabled]="!client.enabled">
                        Clear
                      </button>
                    </div>
                  </div>

                  <div class="team-access-entry access-row" *ngFor="let entry of client.entries">
                    <div class="team-access-entry-copy">
                      <div class="team-access-entry-name operation-name">{{ entry.operationName }}</div>
                      <div class="team-access-entry-meta">
                        <span class="team-access-meta-pill" [ngClass]="getEntryStateClass(client, entry)">
                          {{ getEntryStateLabel(client, entry) }}
                        </span>
                      </div>
                      <div class="team-access-entry-status" *ngIf="entry.operationActive === 0">Inactive</div>
                    </div>

                    <div class="role-select role-select-stack">
                      <label class="operation-enable-toggle" *ngIf="client.accessMode === 'selectedOperations'">
                        <input
                          type="checkbox"
                          [checked]="entry.operationSelected"
                          [disabled]="!client.enabled"
                          (change)="onOperationSelectedChange(client, entry, $any($event.target).checked)"
                        />
                        <span>Operation enabled</span>
                      </label>

                      <ion-select
                        class="role-select-control"
                        interface="popover"
                        [ngModel]="entry.selectedRoleId"
                        (ngModelChange)="onOperationRoleChange(client, entry, $event)"
                        [disabled]="!isEntryInClientScope(client, entry)"
                      >
                        <ion-select-option *ngFor="let role of roleOptions" [value]="role.value">
                          {{ role.label }}
                        </ion-select-option>
                      </ion-select>

                      <div class="operation-assignee-grid" *ngIf="isEntryInClientScope(client, entry)">
                        <div class="operation-assignee-field">
                          <label>Default Manager</label>
                          <ion-select
                            class="role-select-control"
                            interface="popover"
                            [ngModel]="entry.defaultManagerTeamMemberId"
                            (ngModelChange)="onOperationAssigneeChange(client, entry, 'manager', $event)"
                            [disabled]="!isEntryInClientScope(client, entry)"
                          >
                            <ion-select-option value="">Unassigned</ion-select-option>
                            <ion-select-option *ngFor="let member of roleEligibleMembers.managerEligible" [value]="member.teamMemberId">
                              {{ member.teamMemberFirstName }} {{ member.teamMemberLastName }}
                            </ion-select-option>
                          </ion-select>
                        </div>

                        <div class="operation-assignee-field">
                          <label>Default Care Rep</label>
                          <ion-select
                            class="role-select-control"
                            interface="popover"
                            [ngModel]="entry.defaultCareRepTeamMemberId"
                            (ngModelChange)="onOperationAssigneeChange(client, entry, 'careRep', $event)"
                            [disabled]="!isEntryInClientScope(client, entry)"
                          >
                            <ion-select-option value="">Unassigned</ion-select-option>
                            <ion-select-option *ngFor="let member of roleEligibleMembers.careRepEligible" [value]="member.teamMemberId">
                              {{ member.teamMemberFirstName }} {{ member.teamMemberLastName }}
                            </ion-select-option>
                          </ion-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="activeEditor === 'member'">
            <div class="team-access-state" *ngIf="!teamMembers.length">No team members are available for member exceptions.</div>

            <div class="member-access-toolbar" *ngIf="teamMembers.length">
              <div class="member-access-label">Editing exceptions for</div>
              <div class="member-access-member-list">
                <button
                  type="button"
                  class="member-access-member-button"
                  *ngFor="let teamMember of teamMembers"
                  [class.is-active]="selectedTeamMemberId === teamMember.teamMemberId"
                  (click)="selectTeamMember(teamMember.teamMemberId)"
                >
                  {{ teamMember.teamMemberFirstName }} {{ teamMember.teamMemberLastName }}
                </button>
              </div>
              <div class="member-access-actions" *ngIf="selectedTeamMember">
                <button type="button" class="member-access-action-button" (click)="goToSelectedMemberDetails()">
                  Open Member Card
                </button>
                <button
                  type="button"
                  class="member-access-action-button is-emphasis"
                  *ngIf="canImpersonateSelectedMember"
                  (click)="loginAsSelectedMember()"
                >
                  Login as User
                </button>
              </div>
            </div>

            <div class="team-access-state team-access-error" *ngIf="memberLoadError">{{ memberLoadError }}</div>
            <div class="team-access-state" *ngIf="isMemberLoading && !memberLoadError">Loading member access...</div>

            <div class="team-access-groups" *ngIf="!isMemberLoading && !memberLoadError && groupedMemberEntries.length">
              <div class="team-access-group access-card" *ngFor="let group of groupedMemberEntries">
                <div class="team-access-group-name access-card-header">{{ group.groupName }}</div>
                <div class="access-card-body">
                  <div class="team-access-entry member-access-entry access-row" *ngFor="let entry of group.entries">
                    <div class="team-access-entry-copy">
                      <div class="team-access-entry-name operation-name">{{ entry.operationName }}</div>
                      <div class="team-access-entry-meta">
                        <span class="team-access-meta-pill" *ngIf="entry.teamRoleLabel">Team default: {{ entry.teamRoleLabel }}</span>
                        <span class="team-access-meta-pill" *ngIf="entry.directRoleLabel">Direct: {{ entry.directRoleLabel }}</span>
                        <span class="team-access-meta-pill is-emphasis" *ngIf="entry.effectiveRoleLabel">
                          Effective: {{ entry.effectiveRoleLabel }}
                          <ng-container *ngIf="entry.effectiveAccessSourceLabel">({{ entry.effectiveAccessSourceLabel }})</ng-container>
                        </span>
                      </div>
                      <div class="team-access-entry-status" *ngIf="entry.operationActive === 0">Inactive</div>
                    </div>
                    <div class="role-select">
                      <ion-select
                        class="role-select-control"
                        interface="popover"
                        [ngModel]="entry.selectedState"
                        (ngModelChange)="entry.selectedState = $event; onMemberAccessChange()"
                      >
                        <ion-select-option *ngFor="let state of memberAccessStateOptions" [value]="state.value">
                          {{ state.label }}
                        </ion-select-option>
                      </ion-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="team-access-state" *ngIf="!isMemberLoading && !memberLoadError && teamMembers.length && !groupedMemberEntries.length">
              No operations are available for member exceptions.
            </div>
          </ng-container>

          <ng-template #noOperations>
            <div class="team-access-state">No operations are available for assignment.</div>
          </ng-template>
        </div>
      </div>
    </section>
  </div>
</ion-content>